import React, { forwardRef } from "react";
import * as styles from "./Button.module.css";
import { Link } from "gatsby";
export const PrimaryButton = ({ buttonText, className, ...rest }) => {
  return (
    <button className={`${styles?.PrimaryButton} ${className}`} {...rest}>
      {buttonText}
    </button>
  );
};
export const PrimaryButtonLink = ({ buttonLinkText, className, ...rest }) => {
  return (
    <Link className={`${styles?.PrimaryButton} ${className}`} {...rest}>
      {buttonLinkText}
    </Link>
  );
};

export const SecondaryButton = ({ buttonText, className, ...rest }) => {
  const RenderDiv = rest?.to ? Link : "button";
  return (
    <RenderDiv className={`${styles?.SecondaryButton} ${className}`} {...rest}>
      {buttonText}
    </RenderDiv>
  );
};

export const TabButton = ({ tabText, isActive, className, ...rest }) => {
  return (
    <div
      className={`${styles?.TabPrimaryButton} ${
        isActive && styles?.TabPrimaryButtonActive
      } ${className}`}
      {...rest}
    >
      {tabText}
    </div>
  );
};

export const BannerTag = ({ tagText, isActive, black, className, ...rest }) => {
  const RenderDiv = rest?.to ? Link : "div";
  return (
    <RenderDiv
      className={`${styles?.TagBanner} ${isActive && styles?.TagBannerActive} ${
        black && styles?.TagBannerBlackColor
      } ${className}`}
      {...rest}
    >
      {tagText}
    </RenderDiv>
  );
};

export const ViewMoreButton = forwardRef(
  ({ buttonText, isActive, ...rest }, ref) => {
    return (
      <div
        className={`${styles?.ViewMoreButton} ${
          isActive && styles?.ViewMoreButtonActive
        } ${rest?.className}`}
        {...rest}
        ref={ref}
      >
        {buttonText}
      </div>
    );
  }
);

export const PDFDownloader = ({ label, className, ...rest }) => {
  return (
    <a className={`${styles?.PDFButton} ${className}`} {...rest}>
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M27.5 19C27.5 19.1326 27.4473 19.2598 27.3536 19.3536C27.2598 19.4473 27.1326 19.5 27 19.5H23.5V22.5H26C26.1326 22.5 26.2598 22.5527 26.3536 22.6464C26.4473 22.7402 26.5 22.8674 26.5 23C26.5 23.1326 26.4473 23.2598 26.3536 23.3536C26.2598 23.4473 26.1326 23.5 26 23.5H23.5V26C23.5 26.1326 23.4473 26.2598 23.3536 26.3536C23.2598 26.4473 23.1326 26.5 23 26.5C22.8674 26.5 22.7402 26.4473 22.6464 26.3536C22.5527 26.2598 22.5 26.1326 22.5 26V19C22.5 18.8674 22.5527 18.7402 22.6464 18.6464C22.7402 18.5527 22.8674 18.5 23 18.5H27C27.1326 18.5 27.2598 18.5527 27.3536 18.6464C27.4473 18.7402 27.5 18.8674 27.5 19ZM11 21.5C11 22.2956 10.6839 23.0587 10.1213 23.6213C9.55871 24.1839 8.79565 24.5 8 24.5H6.5V26C6.5 26.1326 6.44732 26.2598 6.35355 26.3536C6.25979 26.4473 6.13261 26.5 6 26.5C5.86739 26.5 5.74021 26.4473 5.64645 26.3536C5.55268 26.2598 5.5 26.1326 5.5 26V19C5.5 18.8674 5.55268 18.7402 5.64645 18.6464C5.74021 18.5527 5.86739 18.5 6 18.5H8C8.79565 18.5 9.55871 18.8161 10.1213 19.3787C10.6839 19.9413 11 20.7044 11 21.5ZM10 21.5C10 20.9696 9.78929 20.4609 9.41421 20.0858C9.03914 19.7107 8.53043 19.5 8 19.5H6.5V23.5H8C8.53043 23.5 9.03914 23.2893 9.41421 22.9142C9.78929 22.5391 10 22.0304 10 21.5ZM20 22.5C20 23.5609 19.5786 24.5783 18.8284 25.3284C18.0783 26.0786 17.0609 26.5 16 26.5H14C13.8674 26.5 13.7402 26.4473 13.6464 26.3536C13.5527 26.2598 13.5 26.1326 13.5 26V19C13.5 18.8674 13.5527 18.7402 13.6464 18.6464C13.7402 18.5527 13.8674 18.5 14 18.5H16C17.0609 18.5 18.0783 18.9214 18.8284 19.6716C19.5786 20.4217 20 21.4391 20 22.5ZM19 22.5C19 21.7044 18.6839 20.9413 18.1213 20.3787C17.5587 19.8161 16.7956 19.5 16 19.5H14.5V25.5H16C16.7956 25.5 17.5587 25.1839 18.1213 24.6213C18.6839 24.0587 19 23.2956 19 22.5ZM5.5 14V5C5.5 4.60218 5.65804 4.22064 5.93934 3.93934C6.22064 3.65804 6.60218 3.5 7 3.5H19C19.0657 3.49995 19.1307 3.51284 19.1914 3.53793C19.2521 3.56303 19.3073 3.59983 19.3538 3.64625L26.3538 10.6462C26.4002 10.6927 26.437 10.7479 26.4621 10.8086C26.4872 10.8693 26.5001 10.9343 26.5 11V14C26.5 14.1326 26.4473 14.2598 26.3536 14.3536C26.2598 14.4473 26.1326 14.5 26 14.5C25.8674 14.5 25.7402 14.4473 25.6464 14.3536C25.5527 14.2598 25.5 14.1326 25.5 14V11.5H19C18.8674 11.5 18.7402 11.4473 18.6464 11.3536C18.5527 11.2598 18.5 11.1326 18.5 11V4.5H7C6.86739 4.5 6.74021 4.55268 6.64645 4.64645C6.55268 4.74022 6.5 4.86739 6.5 5V14C6.5 14.1326 6.44732 14.2598 6.35355 14.3536C6.25979 14.4473 6.13261 14.5 6 14.5C5.86739 14.5 5.74021 14.4473 5.64645 14.3536C5.55268 14.2598 5.5 14.1326 5.5 14ZM19.5 10.5H24.7925L19.5 5.20625V10.5Z"
            fill="black"
          />
        </svg>
      </span>
      {label}
    </a>
  );
};

export const PopupButton = forwardRef(
  ({ label, copy, className, ...rest }, ref) => {
    return (
      <button
        className={`${styles?.PopupButton} button-md ${className}`}
        ref={ref}
        {...rest}
      >
        {copy && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M20.25 3.375H8.25C8.15054 3.375 8.05516 3.41451 7.98483 3.48484C7.91451 3.55516 7.875 3.65054 7.875 3.75V7.875H3.75C3.65054 7.875 3.55516 7.91451 3.48484 7.98483C3.41451 8.05516 3.375 8.15054 3.375 8.25V20.25C3.375 20.3495 3.41451 20.4448 3.48484 20.5152C3.55516 20.5855 3.65054 20.625 3.75 20.625H15.75C15.8495 20.625 15.9448 20.5855 16.0152 20.5152C16.0855 20.4448 16.125 20.3495 16.125 20.25V16.125H20.25C20.3495 16.125 20.4448 16.0855 20.5152 16.0152C20.5855 15.9448 20.625 15.8495 20.625 15.75V3.75C20.625 3.65054 20.5855 3.55516 20.5152 3.48484C20.4448 3.41451 20.3495 3.375 20.25 3.375ZM15.375 19.875H4.125V8.625H15.375V19.875ZM19.875 15.375H16.125V8.25C16.125 8.15054 16.0855 8.05516 16.0152 7.98483C15.9448 7.91451 15.8495 7.875 15.75 7.875H8.625V4.125H19.875V15.375Z"
              fill="white"
            />
          </svg>
        )}
        {label}
      </button>
    );
  }
);
